import { Field } from '@sitecore-jss/sitecore-jss/types/layout/models';
import { ImageField, Item, TextField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ImageValue } from '../components';
import { isFilledIn } from './utils';

function getFieldWithInternalKey<T extends { value?: any }>(
  field: T,
  internalFieldKey: string
): T | undefined {
  return field?.value[internalFieldKey] && Object.keys(field.value[internalFieldKey]).length > 0
    ? field
    : undefined;
}

function isFieldFilledIn(
  field: Field | Field<ImageValue> | ImageField | TextField | Item | Item[] | undefined,
  internalFieldKey?: string
): boolean {
  if (!field) return false;
  if (!('value' in field)) return false;
  if (internalFieldKey) {
    return !!getFieldWithInternalKey(field, internalFieldKey);
  }
  return isFilledIn(field?.value);
}

export function getSharedProperty<
  T extends Record<K, Field | Field<ImageValue> | ImageField | TextField | Item | Item[]>,
  K extends keyof T,
>(fields: T | undefined, fieldName: K, internalFieldKey?: string): T[K] | null | undefined {
  if (!fields) return;
  const field = fields?.[fieldName];
  const sharedFieldName = `${fieldName as string}Shared` as keyof T;
  const sharedField = fields?.[sharedFieldName] as T[K];

  const isFieldAbsent = field === undefined && sharedField === undefined;
  if (isFieldAbsent) {
    return undefined;
  }
  const fieldValue = isFieldFilledIn(field, internalFieldKey);
  if (fieldValue) {
    return field;
  }

  const sharedFieldValue = isFieldFilledIn(sharedField, internalFieldKey);
  if (sharedFieldValue) {
    return sharedField;
  }

  return null;
}
